import axios from 'axios';
import { API_BASE_URL, API_RESPONSE } from '../settings/shared/constants';
import { logoutAndPreserveConsent } from '../settings/shared/commonMethods';
import { errorMessage } from '../settings/shared/CommonMessages';

const axiosClient = axios.create({
    baseURL: API_BASE_URL
});

axiosClient.interceptors.request.use(function (config) {
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Add a response interceptor
axiosClient.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data;
}, function (error) {
    const statusCode = error?.response?.status || error?.status;
    
    // Check for 401 Unauthorized - axios errors have status in error.response.status
    if(statusCode === 401){
        // Dispatch custom event for error handling
        window.dispatchEvent(new CustomEvent('httpError', { 
            detail: { 
                statusCode: 401,
                message: errorMessage.sessionExpired,
                error: error
            } 
        }));
        // Navigate to error page with state
        const errorState = encodeURIComponent(JSON.stringify({
            statusCode: 401,
            errorMessage: errorMessage.sessionExpired,
            isHttpError: true
        }));
        window.location.href = `/error?state=${errorState}`;
        logoutAndPreserveConsent();
        return Promise.reject(error);
    }else if(statusCode === 500){
        // Dispatch custom event for 500 Internal Server Error
        window.dispatchEvent(new CustomEvent('httpError', { 
            detail: { 
                statusCode: 500,
                message: error?.response?.data?.errorMessage || error?.response?.data?.message || error?.message || 'Internal Server Error',
                error: error
            } 
        }));
        return Promise.reject(error);
    }else{
        // For other errors, return a structured error response instead of rejecting
        let resp = {
            errorMessage : error?.response?.data?.errorMessage || error?.response?.data?.message || error?.message || 'An error occurred',
            status: API_RESPONSE.FAILED,
            data: error?.response?.data
        }
       return Promise.resolve(resp);
    }
});

export default axiosClient;    
